module.exports = __webpack_public_path__ + "static/media/game-controller.10fbed6b.svg";